import React from 'react'
import Screen from '../Screen'
import { SpotlightScreenProps } from './types'
import ScreenRowLayout from '../Screen/ScreenRowLayout'
import WebcamScreen from '../WebcamScreen'

const SpotlightScreen = (props:SpotlightScreenProps) => (
  <Screen>
    <ScreenRowLayout>
      <WebcamScreen presenter={props.presenter} />
    </ScreenRowLayout>
  </Screen>
)

export default SpotlightScreen